module.exports = __webpack_public_path__ + "media/favicon/favicon-32x32-8a6cf864.png";